"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SET_DISPLAYS_TO_OBSERVE = void 0;
var client_1 = require("@apollo/client");
var fragments_1 = require("../fragments");
exports.SET_DISPLAYS_TO_OBSERVE = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation SetDisplaysToObserve($input: SetDisplaysToObserveInput!) {\n    setDisplaysToObserve(input: $input) {\n      displays {\n        ...Display\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation SetDisplaysToObserve($input: SetDisplaysToObserveInput!) {\n    setDisplaysToObserve(input: $input) {\n      displays {\n        ...Display\n      }\n    }\n  }\n  ", "\n"])), fragments_1.DISPLAY_FRAGMENT);
var templateObject_1;
